module.exports = __webpack_public_path__ + "img/precs1.b739fae5.png";